var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M15.4133 11.2767L10.88 3.11666C10.2708 2.01874 9.42793 1.41666 8.50001 1.41666C7.5721 1.41666 6.72918 2.01874 6.12001 3.11666L1.58668 11.2767C1.01293 12.3179 0.949181 13.3167 1.4096 14.1029C1.87001 14.8892 2.77668 15.3212 3.96668 15.3212H13.0333C14.2233 15.3212 15.13 14.8892 15.5904 14.1029C16.0508 13.3167 15.9871 12.3108 15.4133 11.2767ZM7.96876 6.37499C7.96876 6.08457 8.2096 5.84374 8.50001 5.84374C8.79043 5.84374 9.03126 6.08457 9.03126 6.37499V9.91666C9.03126 10.2071 8.79043 10.4479 8.50001 10.4479C8.2096 10.4479 7.96876 10.2071 7.96876 9.91666V6.37499ZM9.00293 12.5446C8.96751 12.5729 8.9321 12.6012 8.89668 12.6296C8.85418 12.6579 8.81168 12.6792 8.76918 12.6933C8.72668 12.7146 8.68418 12.7287 8.6346 12.7358C8.5921 12.7429 8.54251 12.75 8.50001 12.75C8.45751 12.75 8.40793 12.7429 8.35835 12.7358C8.31585 12.7287 8.27335 12.7146 8.23085 12.6933C8.18835 12.6792 8.14585 12.6579 8.10335 12.6296C8.06793 12.6012 8.03251 12.5729 7.9971 12.5446C7.8696 12.41 7.79168 12.2258 7.79168 12.0417C7.79168 11.8575 7.8696 11.6733 7.9971 11.5387C8.03251 11.5104 8.06793 11.4821 8.10335 11.4537C8.14585 11.4254 8.18835 11.4042 8.23085 11.39C8.27335 11.3687 8.31585 11.3546 8.35835 11.3475C8.45043 11.3262 8.5496 11.3262 8.6346 11.3475C8.68418 11.3546 8.72668 11.3687 8.76918 11.39C8.81168 11.4042 8.85418 11.4254 8.89668 11.4537C8.9321 11.4821 8.96751 11.5104 9.00293 11.5387C9.13043 11.6733 9.20835 11.8575 9.20835 12.0417C9.20835 12.2258 9.13043 12.41 9.00293 12.5446Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }